import AWS from "aws-sdk";
import React from 'react';
// *** import {Link} from 'react-router-dom'
// *** import { userIdFunc, handleErrorFunc } from '../App';
import { handleErrorFunc } from '../App';
import Counter from './Counter';

import { Map, Marker, Popup, TileLayer } from 'react-leaflet';
// *** import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import {Card, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
// *** import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Avatar from 'material-ui/Avatar';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import Paper from 'material-ui/Paper';
// *** import {grey400, darkBlack, lightBlack} from 'material-ui/styles/colors';
import {grey400, darkBlack} from 'material-ui/styles/colors';

import appConfig from '../appConfig';
// *** import {bucketname,tablename,commenttable,toLocaleString,makeCommentKey,noimage,noimageurl,nothumbnailurl,escape_html,createMarkup}  from '../appConfig';
import {bucketname,commenttable,toLocaleString,makeCommentKey,noimage,noimageurl,escape_html,createMarkup}  from '../appConfig';



//===============================
// class Post
//===============================
export default class Post extends  React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      item: {},
      name: "",
      comment: "",
      comments: [],
      commentKey: ""
    };
  }

//===============================
// componentWillMount()
//===============================
  componentWillMount() {
    //console.log("### state="+JSON.stringify(this.props.location.state));
    //console.log("##### IN post expired="+AWS.config.credentials.expired);
    this.setState({item: this.props.location.state});

    const _self = this;
    const item = this.props.location.state;

    let commentKey = makeCommentKey(item.identityId, item.uploadTime);
    this.setState({commentKey: commentKey});
    let dynamo = new AWS.DynamoDB.DocumentClient();

    var param = {
      TableName : commenttable,
      KeyConditionExpression : "commentKey = :commentKey",
      ExpressionAttributeValues : {":commentKey" : commentKey}
    };
    dynamo.query(param, function(err, data) {
        if (err) {
            console.log("### Error="+err);
        } else {
            //console.log("### data="+JSON.stringify(data.Items));
            _self.setState({comments: data.Items});
        }
    });

  }


//===============================
// handleNameChange()
//===============================
  handleNameChange(e) {
    this.setState({name: e.target.value});
  }
//===============================
// handleCommentChange()
//===============================
  handleCommentChange(e) {
    this.setState({comment: e.target.value});
  }


//===============================
// handleSubmit()
//===============================
  handleSubmit(e) {
    e.preventDefault();
    
    if(this.state.name==="" || this.state.comment==="") {
        handleErrorFunc('エラー： 名前またはコメントが空白です' );
        return;
    }

//-------------------------------
// Date
//-------------------------------
    var date = new Date() ;
    //var uploadTime = (date.getTime()).toString() ;  //AWS.DynamoDB()の時はこちらを使う
    var commentTime = date.getTime();
    var commentDate = toLocaleString(date);

//-------------------------------
// DynamoDB putItem
//-------------------------------
    const name = escape_html(this.state.name);
    const comment = escape_html(this.state.comment);

    var docClient = new AWS.DynamoDB.DocumentClient();
    var params = {
        TableName: commenttable,
        Item:{
             commentKey: this.state.commentKey, // ★partition key
             name: name,
             comment: comment,
             commentTime: commentTime,    // ★sort key
             commentDate: commentDate
        }
    };
    docClient.put(params, function(err, data) {
        if(err) {
            console.log("Err: table put :" +err);
        } else {
            console.log("Success: table put ok");
        }
    });


    let comments = this.state.comments;
    comments.push(params.Item);
    this.setState( {comments: comments} );

    this.setState( {name: ""} );
    this.setState( {comment: ""} );

  }


//===============================
// render
//===============================
  render(){

    let list=[];
    this.state.comments.map((item,idx) => {
        list.push (
        <ListItem key={'list'+idx}
          leftAvatar={<Avatar>投稿</Avatar>}
          primaryText={item.name}
          secondaryText={
            <p style={{textAlign: 'left'}}>
              <span style={{color: darkBlack}}>{item.commentDate}</span>
              <br />
              {item.comment}
            </p>
          }
          secondaryTextLines={2}
        />
        );
        list.push ( <Divider inset={true} key={'div'+idx} /> );
        return item  // *** for compile error
    })

    let imgurl = noimageurl;
    if(this.state.item.filename!==noimage) {
        imgurl = 'http://'+bucketname+'.s3-'+appConfig.region+'.amazonaws.com/'+this.state.item.filename;
    }
//----------------------------
    let map=null;
    if(this.state.item.mapUse) {
        let position = this.state.item.position;
        map = (
          <Map center={position} zoom={15}>
            <TileLayer
              url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={position}>
              <Popup>
                <span>A pretty CSS3 popup.<br/>Easily customizable.</span>
              </Popup>
            </Marker>
          </Map>
        );
    }
//----------------------------

    return (
    <div style={{width:'80%', marginLeft: 'auto', marginRight: 'auto'}}>
      <Card>
        <CardHeader
          title={this.state.item.username}
          subtitle={this.state.item.uploadDate}
          avatar={<Avatar>名前</Avatar>}
        />
        <CardMedia
          overlay={<CardTitle title={this.state.item.title}  subtitle="久喜SNS" />}
        >
          <img src={imgurl} alt="" />
        </CardMedia>
        <CardTitle title={this.state.item.title} subtitle="久喜SNS" />
        <CardText style={{fontSize:18}}>
            <div dangerouslySetInnerHTML={createMarkup(this.state.item.story)} />
            <br /><br />
            {map}
        </CardText>
      </Card>
      <br />
      <div  style={{textAlign: 'right', color:grey400}}>
          <Counter identityId={this.state.item.identityId} uploadTime={this.state.item.uploadTime} />
      </div>
      <br /><br />
      <div style={{width:'90%', marginLeft: 'auto', marginRight: 'auto'}}>
        <Paper style={{width: '100%', padding: 30, display: 'inline-block'}} zDepth={1}>
          <h3>コメント投稿してね</h3>
          <form onSubmit={this.handleSubmit.bind(this)}>
            <TextField fullWidth={true}
                 value={this.state.name}
                 hintText="名前"
                 onChange={this.handleNameChange.bind(this)}/><br />
            <TextField fullWidth={true}
                 value={this.state.comment}
                 hintText="コメント（改行で複数行可能です）"
                 multiLine={true}
                 onChange={this.handleCommentChange.bind(this)}/><br />
            <input type="submit" />
          </form>
          <br /><br />
          <List>
            <Subheader>過去のコメント投稿</Subheader>
             {list}
          </List>
        </Paper>
      </div>
    </div>
   );
  }
}




// WEBPACK FOOTER //
// ./src/views/Post.js